export default __webpack_public_path__ + "static/media/06-min.e9e36e19.jpg";